import React from 'react';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import './MainLayout.scss';

interface MainLayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children, showHeader = true }) => {
  return (
    <div className="main-layout">
      {showHeader && <Header />}
      <main className="main-content">{children}</main>
      <Footer />
    </div>
  );
};
